export default {
  activeOffers: ({ publishedCheckouts }) => {
    let offers = []

    if (publishedCheckouts.length !== 0) {
      publishedCheckouts.forEach(current => {
        if (current.status === 'ACTIVE_BY_OFFER') {
          offers = [
            ...offers,
            ...current.activeOffersList || []
          ]
        }
      })
    }
    return offers
  },
  currentActiveOffers: ({ checkoutData }) => checkoutData && checkoutData.activeOffersList ? checkoutData.activeOffersList : [],
  checkoutDataStatus: ({ checkoutData }) => checkoutData && checkoutData.status,
  checkoutDataId: ({ checkoutData }) => checkoutData && checkoutData.id,
  offers: ({ checkoutData, currentProductHotlinks }) => {
    if (!checkoutData?.id) {
      return []
    }

    return currentProductHotlinks.find(hotlink => hotlink.checkoutId === checkoutData.id)?.offers ?? []
  }
}
